module.exports = window;


//////////////////
// WEBPACK FOOTER
// external "window"
// module id = 99
// module chunks = 0 1